import { FichierSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const FichierModel: SelectorModel = {
  name: 'fichiers',
  getSelector: FichierSelectors.selectAllFichiersDictionary,
  isReady: FichierSelectors.selectIsReadyFichier
};
